const {
  zipCodeRegexNumeric,
  onlyNumericNormalize,
  SPACE
} = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 5);

exports.countryDefinition = {
  country: 'Malaysia',
  code: 'MY',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    zipCode: {
      label: 'Postcode',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    },
    city: { label: 'Locality', width: 0.5 },
    stateCode: { label: 'State' }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', SPACE, 'city'],
    ['stateCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', 'city'],
    ['stateCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    { field: 'stateCode' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(5)),
      error: 'Must be 5 characters, 12345'
    }
  ]
};
